
import * as w from '@/helpers_site/textsSite';
const MAX_LEN = 100;

function normalize(value) {
  return (value ?? "").toString().trim();
}

export function validateLoginFields(data, errorSetters, options = {}) {
  const maxLen = options.maxLen ?? MAX_LEN;
  const requiredFields = options.requiredFields ?? Object.keys(errorSetters);

  const normalized = {};
  let isValid = true;

  for (const field of requiredFields) {
    const value = normalize(data[field]);
    normalized[field] = value;

    const hasError = value.length === 0 || value.length > maxLen;

    // seta erro no input correspondente, se existir setter
    const setError = errorSetters[field];
    if (typeof setError === "function" && hasError) setError(w.notNull);

    if (hasError) isValid = false;
  }

  return { isValid, normalized };
}
export function getCookie(name) {
  const v = document.cookie.split("; ").find(x => x.startsWith(name + "="));
  return v ? decodeURIComponent(v.split("=").slice(1).join("=")) : "";
}
export async function apiFetchOrHome(url, init = {}, { failTo = "/" } = {}) {
  const resp = await fetch(url, {
    ...init,
    credentials: "include",
  });

  if (resp.status === 401 || resp.status === 403) {
    window.location.assign(failTo);
    return null; // importante: caller deve checar null
  }

  return resp;
}
export function normalizePasskeyError(err) {
  // axios error
  const apiMsg = err?.response?.data?.error;
  if (apiMsg) return apiMsg;

  // simplewebauthn/browser geralmente lança DOMException
  const msg = err?.message || String(err);

  if (msg.includes('NotAllowedError')) return 'Operação cancelada ou expirada. Tente novamente.';
  if (msg.includes('InvalidStateError')) return 'Esta passkey já está registrada neste dispositivo.';
  if (msg.includes('NotSupportedError')) return 'Seu navegador/dispositivo não suporta passkeys.';
  return 'Não foi possível adicionar a passkey. Tente novamente.';
}
